import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { ChangePasswordRequestBody, ChangePasswordResponse } from "./types";

export class ChangePasswordAPI extends BaseAPI<
    ChangePasswordRequestBody,
    ChangePasswordResponse
> {
    protected route = ApiRoutes.account;
    protected method = RequestMethod.POST;
}
